import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "@me8eon/translation";
import "./EditModeTextarea.scss"
interface EditModeTextareaProps {
    onSend?: (value: string) => void;
    defaultVal: string;
    toggleEdit: () => void
}

export const EditModeTextarea: React.FC<EditModeTextareaProps> = ({
    onSend,
    defaultVal,
    toggleEdit
}) => {
    const [value, setValue] = useState(defaultVal);
    const [sendDisabled, setSendDisabled] = useState(true);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const t = useTranslation();

    // ✨ Auto-grow height based on content
    useEffect(() => {
        const el = textareaRef.current;
        if (el) {
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
        }
    }, [value]);

    const handleSend = () => {
        const trimmed = value.trim();
        if (trimmed !== "") {
            onSend?.(trimmed);
            setValue("");
        }
    };

    // 🖱️ Submit on Enter, new line on Shift+Enter
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    const newValChange = (newVal: string) => {
        const disabledCheck = newVal.trim().length < 1 || newVal === defaultVal;
        console.log({ value, defaultVal, newVal })
        setSendDisabled(disabledCheck)
        setValue(newVal)
    }

    return (
        <div className="editModeTextarea">
            <textarea
                ref={textareaRef}
                value={value}
                onChange={(e) => newValChange(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={t("chatBot.searchAsk")}
                rows={1}
                className="edit-textarea"
            />
            <button
                className="cancel-btn"
                onClick={toggleEdit}
            >
                <EonUiIcon
                    title={t("chatBot.cancelBtn")}
                    size="normal"
                    name="cross"
                    style={{ height: "0" }}
                />
            </button>
            <button
                className={`send-btn ${sendDisabled ? "send-btn--disabled" : "send-btn--enabled"}`}
                onClick={handleSend}
                disabled={sendDisabled}
            >
                <EonUiIcon
                    title={t("chatBot.sendbtn")}
                    size="small"
                    name="send"
                    style={{ color: sendDisabled ? "#cccbca" : "#ea1b0a" }}
                />
            </button>
        </div>
    );
};
